<mat-progress-bar
  *ngIf="(progressBar$ | async)?.visible"
  mode="determinate"
  [value]="(progressBar$ | async)?.visibleProgress!"
></mat-progress-bar>

<router-outlet></router-outlet>
